import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { post } from "../axios-post";

export const apiCallGetDataForMyAuditingEfficiencyTable = async ({
  adminId,
  dateMin,
  dateMax
}: {
  adminId: number;
  dateMin: Date;
  dateMax: Date;
}) => {
  const { status, data, et3Error } = await post<[]>(
    `auditor/getMyAuditingEfficiency`,
    {
      adminId,
      startDateObject: getDateAsObject(dateMin),
      endDateObject: getDateAsObject(dateMax)
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [""],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
